module.exports = __webpack_public_path__ + "static/media/opt.755c1786.proto";